module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_negocios.6816b637.jpg";